// This function save current data in localStorage. We write it because we use it in future more then one time.
const storageSetter = (name, data) => {
  typeof data === "string"
    ? localStorage.setItem(name, data)
    : localStorage.setItem(name, JSON.stringify(data));
};

const storageGetter = name => {
  return JSON.parse(localStorage.getItem(name.toString())) !== null
    ? JSON.parse(localStorage.getItem(name.toString()))
    : [];
};

/**
 * @param {Object | Array} items
 * @returns {Boolean}
 */
const hasItem = items => {
  return items.length > 0 ? true : false;
};

/**
 * @param {Object} obj
 * @param {Array(String)} value
 * @returns Object without params value
 */
const getObjWithoutValue = (obj, value) => {
  const newObj = Object.assign({}, obj);
  value.forEach(val => delete newObj[val]);

  return newObj;
};

export { storageSetter, storageGetter, getObjWithoutValue, hasItem };

export const randomInteger = (min, max) => {
  // случайное число от min до (max+1)
  let rand = min + Math.random() * (max + 1 - min);
  return Math.floor(rand);
};

export const hasJsonStructure = str => {
  if (typeof str !== "string") return false;

  try {
    const result = JSON.parse(str);
    const type = Object.prototype.toString.call(result);

    return type === "[object Object]" || type === "[object Array]";
  } catch (error) {
    return false;
  }
};

export const booleanChecker = item => {
  if (item && (typeof item === "string" || typeof item === "number")) {
    if (typeof item === "string" && item.length === 0) {
      return false;
    }
    return item;
  }
};
